import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Form = styled.form.attrs({
  scrollbarBackground: '#fff'
})`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;

  .ZdsField-container {
    flex: 1;
  }

  textarea {
    ${VerticalStyledScrollBar}
  }
`
